import { render, staticRenderFns } from "./OrcamentoManter.vue?vue&type=template&id=532c171a&"
import script from "./OrcamentoManter.vue?vue&type=script&lang=js&"
export * from "./OrcamentoManter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports